import React from "react";
import { Breadcrumb, Collapse } from "antd";
import Container from "../../../components/Container/Container";
import PageHeader from "../../../components/utility/pageHeader";
import LayoutContent from "@iso/components/utility/layoutContent";
import webhookTextEN from "./webhook-en.md";
import webhookTextPT from "./webhook-pt.md";
import webhookTextES from "./webhook-es.md";
import webhookResponse from "./webhookResponse.md";
import { panel } from "./data/panel";
import { useSelector } from "react-redux";
import Markdown from "../../../components/Markdown";

export default function Webhook() {
  const { locale } = useSelector((state) => state.LanguageSwitcher.language);

  const webhookText =
    locale === "pt-BR"
      ? webhookTextPT
      : locale === "es-ES"
        ? webhookTextES
        : webhookTextEN;

  return (
    <Container>
      <PageHeader>
        <div className="flex items-center justify-start">
          <Breadcrumb
            separator={
              <div className="!justify-center !items-center">
                <svg
                  width="6"
                  height="10"
                  viewBox="0 0 6 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.292893 0.292893C-0.0976311 0.683418 -0.0976311 1.31658 0.292893 1.70711L3.58579 5L0.292893 8.29289C-0.0976315 8.68342 -0.0976315 9.31658 0.292893 9.70711C0.683417 10.0976 1.31658 10.0976 1.70711 9.70711L5.70711 5.70711C6.09763 5.31658 6.09763 4.68342 5.70711 4.29289L1.70711 0.292893C1.31658 -0.097631 0.683418 -0.0976311 0.292893 0.292893Z"
                    fill="#7D7D7D"
                  />
                </svg>
              </div>
            }
            items={[
              {
                title: "Docs",
                className: "!font-normal !pointer-events-none !text-lg",
              },
              {
                title: "Webhook",
                className: "!text-primary !font-semibold !text-lg",
              },
            ]}
          />
        </div>
      </PageHeader>
      <LayoutContent>
        <div className="grid md:grid-cols-2 grid-cols-1 gap-x-5">
          <div className="col-span-1 overflow-auto mb-5">
            <div className="mb-5">
              <Markdown content={webhookText} />
            </div>
            <Collapse
              className="rounded-md"
              expandIconPosition={"start"}
              items={panel}
            />
          </div>
          <div className="sticky top-0 md:h-screen py-5">
            <Markdown content={webhookResponse} />
          </div>
        </div>
      </LayoutContent>
    </Container>
  );
}
